import { AxiosResponse } from 'axios';
import environment from '@environment';
import { FeatureFlag } from 'core/enums/feature-flag';
import { PermissionType } from 'core/enums/permission-type';
import { FeatureFlagDTO, FeatureFlagsDTO } from 'core/models/api-dto/feature-flags.dto';
import { EndpointHelper } from 'core/services/endpoint.helper';
import { HttpClient } from 'core/services/http';

export class FeatureService {
  private static apiBuilder = new EndpointHelper(`${environment.UMBRACO_API_URI}`);

  static getFeatures(culture: string, site: string): Promise<Record<FeatureFlag, PermissionType>> {
    const url = this.apiBuilder.createUrl('SelfServiceFeatures')
      .addRouteParam('get')
      .addQueryParam('culture', culture?.toLocaleLowerCase())
      .addQueryParam('site', site?.toLocaleLowerCase())
      .addQueryParam('clearCache', true)
      .build();

    return HttpClient.GetInstance.get<FeatureFlagsDTO>(url)
      .then(
        (res: AxiosResponse<FeatureFlagsDTO>) => this.mapFeaturesToObject(res?.data?.selfServiceFeaturesManagement) as Record<FeatureFlag, PermissionType>
      );
  }

  static mapFeaturesToObject(features: FeatureFlagDTO[] = []): Record<FeatureFlag, PermissionType> {
    return features.reduce((prev, flag) => {
      const permission = flag.canEdit ? PermissionType.Edit : flag.canView ? PermissionType.View : PermissionType.None;
      if (!FeatureFlag[flag.feature]) {
        return prev;
      }
      return {
        ...prev,
        [FeatureFlag[flag.feature]]: flag.feature.includes('Route') && permission >= 1 ? PermissionType.Route : permission
      };
    }, {} as Record<FeatureFlag, PermissionType>)
  }
}